import CampaignCustomFieldResourceModel from '../../generated/types/model/resource/CampaignCustomFieldResourceModel';

export default class CampaignCustomFieldResourceViewModel extends CampaignCustomFieldResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
